export default __webpack_public_path__ + "static/0310-bc674130f939db50e558ac62c9de0b5b.png";